<template>
	<div :key="container" class="row items-center full-height">
		<div class="col-12 container">
			<vue-plyr
				ref="plyr"
				:key="key"
				:options="{
					listeners: { seek: seekVideo },
					hideControls: true,
					speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] }
				}"
			>
				<video
					playsinline
					webkit-playsinline
					ref="player"
					id="player"
					@play="playVideo"
					@pause="pauseVideo"
					@ended="endedVideo"
					@timeupdate="videoTimeUpdated"
					@loadedmetadata="metaData"
				>
					<source :src="`${getResource}#t=${activity.current_time}`" :type="getMime" />
					<source
						:src="`${activity.resource}#t=${activity.current_time}`"
						:type="$mime.lookup(activity.resource.split('?')[0])"
					/>
				</video>
			</vue-plyr>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { uid } from 'quasar'
import Hls from 'hls.js'

export default {
	name: 'VideoPlayer',

	props: ['activity'],

	data() {
		return {
			id_course: '',
			id_trail: '',
			interval: null,
			current_time: 0,
			total_time: '',
			changed_time: false,
			key: 0,
			last_known_position: 0,
			hls_not_supported: false,
			bunny_video_not_found: false,
			container: null,
			api_url: '',
		}
	},

	computed: {
		...mapGetters({
			activities: 'activities/activities',
			hierarchy_order: 'activities/hierarchy_order',
			id: 'activities/id',
			offline_activities: 'offline_course/activities',
		}),

		getResource() {
			let offline_activity = this.offline_activities.find(
				(e) => e.item_id === this.activity.item_id
			)

			if (offline_activity) {
				return offline_activity.src
			} else if (this.activity.fallback) {
				return this.activity.fallback
			} else if (this.activity.resource) {
				return this.activity.resource
			} else return ''
		},

		getMime() {
			let offline_activity = this.offline_activities.find(
				(e) => e.item_id === this.activity.item_id
			)

			if (offline_activity) {
				return this.$mime.lookup(offline_activity.src)
			} else if (this.activity.fallback && !this.bunny_video_not_found) {
				this.$mime.lookup(this.activity.fallback)
			} else if (this.activity.resource) {
				return this.$mime.lookup(this.activity.resource.split('?')[0])
			} else return ''
		},

		player() {
			const player = document.getElementById('player')
			return player
			// return this.$refs.plyr.player ? this.$refs.plyr.player : null
		},
	},

	methods: {
		sendPosition() {
			if (
				this.$isInvalidNumericString(this.current_time) ||
				this.$isInvalidNumericString(this.total_time)
			)
				return

			if (Math.ceil(this.current_time) >= this.last_known_position && !this.activity.user_watch) {
				let fd = new FormData()
				fd.append('current_time', Math.ceil(this.current_time).toString())
				fd.append('total_time', Math.ceil(this.total_time).toString())
				fd.append('id_group_training_module', this.activity.type_id)

				this.last_known_position = this.current_time

				this.$axios
					.post(this.api_url, fd)
					.then(() => {
						this.updatePosition()
					})
					.catch((e) => {
						console.log(e)
					})
			} else this.updatePosition()
		},

		sendPositionOnExit() {
			if (
				this.$isInvalidNumericString(this.current_time) ||
				this.$isInvalidNumericString(this.total_time)
			)
				return

			let fd = new FormData()
			fd.append('current_time', this.current_time)
			fd.append('total_time', this.total_time)
			fd.append('id_group_training_module', this.activity.type_id)
			this.updatePosition()

			this.$axios
				.post(this.api_url, fd)
				.then(() => {})
				.catch((e) => {
					console.log(e)
				})
		},

		updatePosition() {
			this.updateActivityData({ current_time: this.current_time })
		},

		updateActivityData(obj) {
			this.$store.dispatch('activities/SET_ACTIVITY_DATA', [this.activity, obj])
		},

		playVideo() {
			if (!this.changed_time && this.player) {
				this.player.currentTime = this.activity.current_time
				this.changed_time = true
			}

			this.interval = setInterval(() => {
				this.sendPosition()
			}, 15000)
		},

		pauseVideo() {
			clearInterval(this.interval)
			if (this.current_time > this.last_known_position + 5) {
				this.sendPosition()
			}
		},

		endedVideo() {
			/*
				rafael:
					Houveram problemas onde o usuário não conseguiu enviar para o db, user_watch, true
					acreditamos que possa ser relacionado a mudança no current_time onde o current_time está maior do que o tempo total de vídeo
					se voltar a ter esse problema, investigar esse caminho primeiro,
					olhar também total_time, fazer validação com isso
			*/
			if (!this.activity.user_watch) {
				this.$q.loading.show()
				this.sendPosition()
				clearInterval(this.interval)
				this.updateActivityData({ current_time: this.current_time, user_watch: true })
				setTimeout(() => {
					// Dar tempo para o back mudar a atividade para user_watch: true
					this.$emit('finish')
				}, 750)
				this.$q.loading.hide()
			} else {
				this.updateActivityData({ current_time: this.total_time })
				this.last_known_position = this.total_time
			}
		},

		videoTimeUpdated(val) {
			this.current_time = val.srcElement.currentTime
		},

		metaData(val) {
			this.total_time = val.srcElement.duration
		},

		seekVideo(e) {
			let currentPercent = (100 * this.current_time) / this.total_time
			let lastPosPercent = (100 * this.last_known_position) / this.total_time
			let seekPercent = e.srcElement.value
			if (
				seekPercent < parseInt(currentPercent.toFixed(2)) ||
				seekPercent < parseInt(lastPosPercent.toFixed(2)) ||
				this.activity.user_watch
			)
				return e
			else return false
		},

		moveToFallbackOnError() {
			if (this.hls_not_supported) {
				this.updateActivityData({ playlist: null })
			} else {
				this.bunny_video_not_found = true
				this.updateActivityData({ playlist: null, fallback: null })
			}
			setTimeout(() => {
				this.container = uid()
				this.key = uid()
			}, 500)
		},

		videoStreaming() {
			if (this.activity.playlist) {
				let url = this.activity.playlist
				const video = document.getElementById('player')
				const defaultOptions = {}

				if (false) {
					const bindedMoveToFallBack = this.moveToFallbackOnError.bind(this)
					const hls = new Hls()

					hls.on(Hls.Events.MANIFEST_PARSED, function () {
						const availableQualities = hls.levels.map((l) => l.height)

						defaultOptions.quality = {
							default: availableQualities[0],
							options: availableQualities,
							forced: true,
							onChange: (e) => updateQuality(e),
						}
					})

					hls.loadSource(url)
					hls.attachMedia(video)

					hls.on(Hls.Events.ERROR, function (event, data) {
						if (data.fatal) {
							switch (data.type) {
								case Hls.ErrorTypes.NETWORK_ERROR:
									// try to recover network error
									console.error('fatal network error encountered, try to recover')
									hls.startLoad()
									bindedMoveToFallBack()
									break
								case Hls.ErrorTypes.MEDIA_ERROR:
									console.warning('fatal media error encountered, try to recover')
									// bindedMoveToFallBack()
									hls.recoverMediaError()
									break
								default:
									// cannot recover
									hls.destroy()
									break
							}
						}
					})

					window.hls = hls
				} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
					video.src = url
					video.addEventListener('canplay', function () {
						video.play()
					})
				} else {
					this.hls_not_supported = true
					this.moveToFallbackOnError()
				}

				function updateQuality(newQuality) {
					window.hls.levels.forEach((level, levelIndex) => {
						if (level.height === newQuality) {
							console.log('Found quality match with ' + newQuality)
							window.hls.currentLevel = levelIndex
						}
					})
				}
			}
		},

		handleKeydown(event) {
			if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
				this.$refs.plyr.player.currentTime = this.current_time
			}
		},
	},

	mounted() {
		this.$refs.plyr.player.on('keydown', this.handleKeydown, this)

		if (!this.activity.user_watch) this.last_known_position = this.activity.current_time
		if (this.id_trail === '')
			this.api_url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
		else
			this.api_url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`
		// if (this.activity.playlist) this.videoStreaming()
	},

	created() {
		this.key = uid()
		if (this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
		if (this.$route.params.id) this.id_course = this.$route.params.id
	},

	beforeUnmount() {
		this.$refs.plyr.player.off('keydown', this.handleKeydown)

		if (this.last_known_position <= this.current_time && !this.activity.user_watch) {
			this.sendPositionOnExit()
		}
		clearInterval(this.interval)
	},

	unmounted() {
		if (window.hls) window.hls.destroy()
	},
}
</script>

<style lang="scss">
.container {
	height: 80% !important;
}
</style>
